import { render, staticRenderFns } from "./MyMessage.vue?vue&type=template&id=41426bce&scoped=true"
import script from "./MyMessage.vue?vue&type=script&lang=js"
export * from "./MyMessage.vue?vue&type=script&lang=js"
import style0 from "./MyMessage.vue?vue&type=style&index=0&id=41426bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41426bce",
  null
  
)

export default component.exports